<!--個人基本資料-->
<div class="page-container">
  <!--title 標題-->
  <div class="page-title-block">
    <h2 class="page-title">{{ 'reserve-info.title' | translate }}</h2>
    <p class="page-subtitle">{{ 'reserve-info.subtitle' | translate }}</p>
    <!-- <div class="page-subtitle-block">
      <img
        width="26"
        height="26"
        ngSrc="assets/img/i-clock-user.svg"
        alt="clock-user"
      />
      <p>{{ 'reserve-info.message' | translate }}</p>
    </div> -->
  </div>

  <!--個人基本資料-->
  <form
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="card-content register-card-content"
  >
    <div class="register-card-title-block">
      <h3 class="register-card-title">
        {{ 'reserve-info.basic-info' | translate }}
      </h3>
      <p class="register-card-subtitle">
        {{ 'reserve-info.basic-info-subtitle' | translate }}
      </p>
    </div>
    <div class="input-block">
      <label class="input-title" for="gender">{{
        'reserve-info.gender' | translate
      }}</label>
      <mat-radio-group id="gender" formControlName="gender">
        <mat-radio-button [value]="API_PARAMS.GENDER.MALE"
          >{{ 'reserve-info.gender-male' | translate }}
        </mat-radio-button>
        <mat-radio-button [value]="API_PARAMS.GENDER.FEMALE"
          >{{ 'reserve-info.gender-female' | translate }}
        </mat-radio-button>
      </mat-radio-group>
      @if (showError && form.get('gender')?.invalid) {
        <mat-error class="input-error-msg">{{
          'error.gender-error.required' | translate
        }}</mat-error>
      }
    </div>
    <div class="input-block">
      <label class="input-title" for="birthday">{{
        'reserve-info.birthday' | translate
      }}</label>
      <div class="input-calculator-block">
        <div class="birthday-group">
          <div
            class="birthday-field"
            [ngClass]="{ 'input-error': isYearInvalid || showBirthdayEmptyError }"
          >
            <input
              id="birthday"
              type="tel"
              inputmode="numeric"
              appNumericOnly
              maxlength="4"
              class="birthday-input"
              [placeholder]="'reserve-info.birthday-year' | translate"
              [(ngModel)]="birthYear"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onBirthdayPartChange(); autoFocusNext('year', monthInput)"
            />
            <span class="birthday-unit">{{ 'reserve-info.year-unit' | translate }}</span>
          </div>
          <div
            class="birthday-field birthday-field-sm"
            [ngClass]="{ 'input-error': isMonthInvalid || showBirthdayEmptyError }"
          >
            <input
              #monthInput
              type="tel"
              inputmode="numeric"
              appNumericOnly
              maxlength="2"
              class="birthday-input"
              [placeholder]="'reserve-info.birthday-month' | translate"
              [(ngModel)]="birthMonth"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onBirthdayPartChange(); autoFocusNext('month', dayInput)"
            />
            <span class="birthday-unit">{{ 'reserve-info.month-unit' | translate }}</span>
          </div>
          <div
            class="birthday-field birthday-field-sm"
            [ngClass]="{ 'input-error': isDayInvalid || showBirthdayEmptyError }"
          >
            <input
              #dayInput
              type="tel"
              inputmode="numeric"
              appNumericOnly
              maxlength="2"
              class="birthday-input"
              [placeholder]="'reserve-info.birthday-day' | translate"
              [(ngModel)]="birthDay"
              [ngModelOptions]="{ standalone: true }"
              (ngModelChange)="onBirthdayPartChange()"
            />
            <span class="birthday-unit">{{ 'reserve-info.day-unit' | translate }}</span>
          </div>
          <div
            class="input-calculator-msg"
            [ngClass]="{
              'input-none':
                (showError || birthdayFilled) && form.get('birthday')?.hasError('invalidAge'),
            }"
          >
            <span>{{
              'reserve-info.current-age' | translate: { age: age }
            }}</span>
          </div>
        </div>
        <div class="input-group input-btn-right">
          @if (showBirthdayEmptyError) {
            <mat-error class="input-error-msg">{{
              'error.birthday-error.year' | translate
            }}</mat-error>
          } @else if (isYearInvalid) {
            <mat-error class="input-error-msg">{{
              'error.birthday-error.year' | translate
            }}</mat-error>
          } @else if (isMonthInvalid) {
            <mat-error class="input-error-msg">{{
              'error.birthday-error.month' | translate
            }}</mat-error>
          } @else if (isDayInvalid) {
            <mat-error class="input-error-msg">{{
              'error.birthday-error.day' | translate
            }}</mat-error>
          } @else if ((showError || birthdayFilled) && form.get('birthday')?.invalid) {
            <mat-error class="input-error-msg">
              <span [innerHTML]="getBirthdayErrorMessage()"></span>
            </mat-error>
          }
        </div>
      </div>
    </div>

    <!--選擇女性：出現的選項-->
    @if (isFemale) {
      <div class="input-block">
        <label class="input-title" for="status">{{
          'reserve-info.are-you-in-following-status' | translate
        }}</label>
        <mat-radio-group id="status" formControlName="status">
          <mat-radio-button [value]="API_PARAMS.FEMALE_STATUS.PREGNANCY"
            >{{ 'reserve-info.pregnancy' | translate }}
          </mat-radio-button>
          <mat-radio-button
            [value]="API_PARAMS.FEMALE_STATUS.POSTPARTUM_BREASTFEEDING"
            >{{ 'reserve-info.postpartum-breastfeeding' | translate }}
          </mat-radio-button>
          <mat-radio-button [value]="API_PARAMS.FEMALE_STATUS.NONE"
            >{{ 'reserve-info.none-of-above' | translate }}
          </mat-radio-button>
        </mat-radio-group>
        @if (showError && form.get('status')?.invalid) {
          <mat-error class="input-error-msg">{{
            'error.female-status-error.required' | translate
          }}</mat-error>
        }
      </div>
      <div class="input-block">
        <label class="input-title" for="menopausal">{{
          'reserve-info.are-you-menopausal' | translate
        }}</label>
        <mat-radio-group id="menopausal" formControlName="menopausal">
          <mat-radio-button value="true">{{
            'common.radio-button.yes' | translate
          }}</mat-radio-button>
          <mat-radio-button value="false">{{
            'common.radio-button.no' | translate
          }}</mat-radio-button>
        </mat-radio-group>
        @if (showError && form.get('menopausal')?.invalid) {
          <mat-error class="input-error-msg">{{
            'error.female-menopausal-error.required' | translate
          }}</mat-error>
        }
      </div>
    }

    <!--固定按鈕區塊-->
    <div class="page-btn-block">
      <button
        mat-button
        type="button"
        class="btn-outline-primary btn-size-l"
        (click)="handlePreviousClick()"
      >
        {{ 'common.button.previous' | translate }}
      </button>
      <button mat-button type="submit" class="btn-fill-primary btn-size-l">
        {{ 'common.button.next' | translate }}
      </button>
    </div>
  </form>
</div>
